import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';

export interface AddAdminStaffPayload {
  userName: string;
  emailAddress: string;
  phoneNumber: string;
  role: string;
  status: string;
}

export interface EditAdminStaffPayload {
  staffId: string;
  userName: string;
  emailAddress: string;
  phoneNumber: string;
  role: string;
  status: string;
}

const addAdminStaff = (client: AxiosInstance) => async (payload: AddAdminStaffPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.ADD_ADMIN_STAFF, payload)).data;
};

const editAdminStaff = (client: AxiosInstance) => async (payload: EditAdminStaffPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.EDIT_ADMIN_STAFF, payload)).data;
};

const deleteAdminStaff = (client: AxiosInstance) => async (staffId: string) => {
  return (
    await client.post<{ message: string }>(API_ROUTES.DELETE_ADMIN_STAFF, {
      staffId,
    })
  ).data;
};
const resetAdminStaffPassword = (client: AxiosInstance) => async (staffId: string) =>
  (await client.post<{ message: string }>(API_ROUTES.RESET_ADMIN_STAFF_PASSWORD, { staffId })).data;

const updateAdminStaffStatus = (client: AxiosInstance) => async (payload: { staffId: string; status: string }) =>
  (await client.post<{ message: string }>(API_ROUTES.UPDATE_ADMIN_STAFF_STATUS, payload)).data;

export const adminStaffMutations = {
  addAdminStaff,
  deleteAdminStaff,
  editAdminStaff,
  resetAdminStaffPassword,
  updateAdminStaffStatus,
};
